<div class="container">
  <div class="text-center">
    <h2>
      <strong class="mainHeading slide-in-left">Push Notification</strong>
    </h2>
  </div>

  <div class="row slide-up">
    <div class="col-lg-4 col-md-4">
      <button
        class="btn btn-success"
        ngbTooltip="Create City"
        tooltipClass="custom-tooltip"
        (click)="openModal(content)"
      >
        <span><i class="bi bi-plus me-2"></i></span> New
      </button>
    </div>
  </div>

  <div class="card shadow-lg p-3 mt-1 slide-up">
    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-3"
    >
      <h2 class="mb-0">Push Notifications List</h2>
      <div class="col-lg-3 col-md-4 col-sm-12 mt-2 mt-md-0">
        <input
          type="text"
          class="form-control search"
          placeholder="Search"
          (input)="search($event)"
        />
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-striped mx-auto">
        <thead class="table-light">
          <tr class="text-center">
            <th>Title</th>
            <th>Description</th>
            <th>Screen</th>
            <th>User Type</th>
            <th>Arabic Title</th>
            <th>Arabic Desc</th>
            <th>Data Content</th>
            <th>Remarks</th>
            <th>Notification Key</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedData" class="text-center">
            <td>{{ row.title }}</td>
            <td class="custom-width">{{ row.description }}</td>
            <td>{{ row.screenNumber }}</td>
            <td>
              @switch (row.userType.toString()) { @case('1') {Individual
              Requester} @case('2') {Corporate Requester} @case('3') { Dumpster
              } @case('4') { Dumpyard} }
            </td>
            <td>{{ row.ar_Title }}</td>
            <td class="custom-width">{{ row.ar_Description }}</td>
            <td>{{ row.dataContent }}</td>
            <td>{{ row.remarks }}</td>
            <td>{{ row.notificationKey }}</td>
            <td class="text-center">
              <i
                class="bi bi-plus-square text-primary me-2"
                style="cursor: pointer"
                title="Edit"
                (click)="openEditModal(content, row)"
              ></i>

              <i
                class="bi bi-trash text-danger"
                style="cursor: pointer"
                title="Delete"
                (click)="openDeleteModal(deleteModal, row)"
              ></i>
            </td>
          </tr>
          @if (pagedData?.length == 0) {
          <tr>
            <td class="text-center" colspan="10">
              <app-no-data-found></app-no-data-found>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Centered Pagination -->
    @if (pagedData?.length >= 1) {
    <div class="d-flex justify-content-between align-items-center mt-3 px-2">
      <div>
        <label class="me-2">Entries per page:</label>
        <select
          class="form-select d-inline-block w-auto"
          [(ngModel)]="pageSize"
          (change)="onPageChange(1)"
        >
          <option *ngFor="let size of pageSizes" [value]="size">
            {{ size }}
          </option>
        </select>
      </div>

      <ngb-pagination
        [collectionSize]="filteredList?.length || 0"
        [(page)]="currentPage"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        [maxSize]="3"
        [rotate]="true"
        [ellipses]="true"
        [boundaryLinks]="true"
      ></ngb-pagination>

      <div *ngIf="filteredList?.length > 0" class="text-muted mb-3 ms-3">
        <strong>
          Showing {{ (currentPage - 1) * pageSize + 1 }} to
          {{
            currentPage * pageSize > filteredList?.length
              ? filteredList?.length
              : currentPage * pageSize
          }}
          of {{ filteredList?.length }} entries
        </strong>
      </div>
    </div>
    }
  </div>
</div>

<!-- Modal Template -->
<ng-template #content let-modal>
  <div class="modal-header custom-modal-header">
    <h2 class="modal-title mt-2">
      {{ isEditMode ? "Edit Push Notification" : "Create Push Notification" }}
    </h2>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="pushForm">
      <div class="row mb-3">
        <div class="col-md-6">
          <label>Title</label>
          <input
            type="text"
            class="form-control"
            formControlName="Title"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['Title'].invalid &&
                pushForm.controls['Title'].touched
            }"
          />
        </div>
        <div class="col-md-6">
          <label>Arabic Title</label>
          <input
            type="text"
            class="form-control"
            formControlName="Ar_Title"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['Ar_Title'].invalid &&
                pushForm.controls['Ar_Title'].touched
            }"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label>Screen Number</label>
          <input
            type="text"
            (keypress)="onlyNumbers($event)"
            class="form-control"
            formControlName="ScreenNumber"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['ScreenNumber'].invalid &&
                pushForm.controls['ScreenNumber'].touched
            }"
          />
        </div>
        <div class="col-md-6">
          <label>User Type</label>
          <input
            type="text"
            class="form-control"
            formControlName="UserType"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['UserType'].invalid &&
                pushForm.controls['UserType'].touched
            }"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label>Description</label>
          <textarea
            type="text"
            class="form-control"
            formControlName="Description"
            rows="4"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['Description'].invalid &&
                pushForm.controls['Description'].touched
            }"
          ></textarea>
        </div>
        <div class="col-md-6">
          <label>Arabic Description</label>
          <textarea
            type="text"
            class="form-control"
            formControlName="Ar_Description"
            rows="4"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['Ar_Description'].invalid &&
                pushForm.controls['Ar_Description'].touched
            }"
          ></textarea>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label>Data Content</label>
          <textarea
            type="text"
            class="form-control"
            formControlName="dataContent"
            rows="4"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['dataContent'].invalid &&
                pushForm.controls['dataContent'].touched
            }"
          ></textarea>
        </div>
        <div class="col-md-6">
          <label>Remarks</label>
          <textarea
            type="text"
            class="form-control"
            formControlName="Remarks"
            rows="4"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['Remarks'].invalid &&
                pushForm.controls['Remarks'].touched
            }"
          ></textarea>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <label>Notification Key</label>
          <input
            type="text"
            class="form-control"
            formControlName="notificationKey"
            [ngClass]="{
              'invalid-field':
                pushForm.controls['notificationKey'].invalid &&
                pushForm.controls['notificationKey'].touched
            }"
          />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      *ngIf="!isEditMode"
      (click)="createNotification()"
    >
      Save
    </button>
    <button class="btn btn-primary" *ngIf="isEditMode" (click)="update()">
      Update
    </button>
    <button class="btn btn-secondary" (click)="modal.dismiss('cancel')">
      Cancel
    </button>
  </div>
</ng-template>

<ng-template #deleteModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Confirm Deletion</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      Are you sure you want to delete the title
      <strong>"{{ selectedTitle }}"</strong>?
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="deleteNotification()">
      Delete
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
  </div>
</ng-template>

@if(isPageLoading) {
<app-loader></app-loader>
}
